<template lang="pug">
  include /mixins
  pretty-stars(
    :star-size="18"
    :padding="0"
    :read-only="!!localRating"
    v-model="form.object_rating"
    @rating-selected="send"
  )
</template>

<script>
import { RatingCreate } from '@api/vendor.service'
import { AnswerMessage } from '@utils/submit'

export default {
  props: {
    item_id: {},
    item_type: {},
    user_name: {},
    user_email: {},
    rating: {},
  },

  data() {
    return {
      localRating: this.rating,
      form: {
        element: {
          type: this.item_type,
          id: this.item_id,
        },
        name: this.user_name,
        email: this.user_email,
        object_rating: this.rating ? Math.round(this.rating) : null,
        product_quality: null,
        packaging_quality: null,
        efficiency: null,
      },
      non_field_errors: '',
      isLoad: false,
    }
  },

  methods: {
    async send() {
      const formdata = JSON.parse(JSON.stringify(this.form))

      formdata.product_quality = formdata.object_rating
      formdata.packaging_quality = formdata.object_rating
      formdata.efficiency = formdata.object_rating

      const res = await RatingCreate.execute({}, formdata)

      this.localRating = formdata.object_rating

      AnswerMessage(res, this)
    },
  },
}
</script>
